import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../colorVars';
import style from './SaveButton.module.css';

export const SaveButton = ({ size, backgroundColor, clickHandler }) => {
  return (
    <div
      className={style.container}
      style={{ width: size + 'px', height: size + 'px', backgroundColor }}
      onClick={clickHandler}
    >
      <svg
        // version="1.1"
        // id="Capa_1"
        // xmlns="http://www.w3.org/2000/svg"
        // x="0px"
        // y="0px"
        viewBox="0 0 486 486"
        style={{ enableBackground: 'new 0 0 486 486' }}
        xmlSpace="preserve"
        fill={colors.lightGrey}
      >
        <g>
          <g>
            <path
              d="M473.7,485.75c6.8,0,12.3-5.5,12.3-12.3v-359.8c0-3.6-1.6-7-4.3-9.3L363,2.85c-0.2-0.2-0.4-0.3-0.6-0.4
        c-0.3-0.2-0.5-0.4-0.8-0.6c-0.4-0.2-0.7-0.4-1.1-0.6c-0.3-0.1-0.6-0.3-0.9-0.4c-0.4-0.2-0.9-0.3-1.3-0.4c-0.3-0.1-0.6-0.2-0.9-0.2
        c-0.8-0.1-1.5-0.2-2.3-0.2H12.3C5.5,0.05,0,5.55,0,12.35v461.3c0,6.8,5.5,12.3,12.3,12.3h461.4V485.75z M384.5,461.25h-283v-184.1
        c0-3.7,3-6.6,6.6-6.6h269.8c3.7,0,6.6,3,6.6,6.6V461.25z M161.8,24.45h180.9v127.8c0,0.8-0.6,1.4-1.4,1.4h-178
        c-0.8,0-1.4-0.7-1.4-1.4V24.45H161.8z M24.6,24.45h112.8v127.8c0,14.3,11.6,25.9,25.9,25.9h178c14.3,0,25.9-11.6,25.9-25.9V38.75
        l94.2,80.6v341.9H409v-184.1c0-17.2-14-31.1-31.1-31.1H108.1c-17.2,0-31.1,14-31.1,31.1v184.2H24.6V24.45z"
            />
            <path
              d="M227.4,77.65h53.8v32.6c0,6.8,5.5,12.3,12.3,12.3s12.3-5.5,12.3-12.3v-44.8c0-6.8-5.5-12.3-12.3-12.3h-66.1
        c-6.8,0-12.3,5.5-12.3,12.3S220.7,77.65,227.4,77.65z"
            />
            <path
              d="M304.5,322.85h-123c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h123c6.8,0,12.3-5.5,12.3-12.3
        S311.3,322.85,304.5,322.85z"
            />
            <path
              d="M304.5,387.75h-123c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h123c6.8,0,12.3-5.5,12.3-12.3
			S311.3,387.75,304.5,387.75z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

SaveButton.propTypes = {
  backgroundColor: PropTypes.any,
  size: PropTypes.number,
  clickHandler: PropTypes.func,
};
